'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'disease';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f7fa';
var svgPathData = 'M459.6 179.6l-60.74-20.5c-9.748-3.25-16.87-9.875-18.1-17.62l-14.5-54c-6.874-25.5-27.62-45-55.74-52.5c-30.87-7.1-63.12 .25-84.24 21.62L183.6 99.25c-6.999 7.125-18.62 11-30.12 10.13l-65.11-5c-33.74-2.5-65.11 13.25-79.99 40.25c-12.87 23.38-10.87 50.25 5.374 72l34.87 46.88c4.624 6.125 5.374 13.12 1.1 19.62l-25.62 50.88c-11.87 23.38-9.249 49.88 6.874 70.88c19.25 24.88 52.99 36.37 86.11 29.37l63.37-13.75c11.37-2.375 23.87 0 32.37 6.375l49.24 36.37c15.12 11 33.24 16.88 51.87 16.75c12.87 0 25.5-2.75 37.24-8c25.37-11.62 41.74-33.75 43.74-59.38l4.249-55.25c.4999-7.375 5.999-14.38 14.62-18.75l56.24-28.38c27.25-13.75 42.89-39.65 40.89-67.52C509.7 213.1 489.7 189.8 459.6 179.6zM449.3 267.4l-56.24 28.38c-23.75 12-38.99 33.62-40.87 58l-4.249 55.12c-.8748 11.37-11.37 17.37-15.75 19.37c-10.25 4.75-26.1 6.5-40.74-3.5l-49.12-36.5c-14.75-10.87-33.24-16.62-51.99-16.62c-6.374 0-12.75 .625-18.1 2l-63.37 13.62c-16.1 3.75-31.5-3.25-37.99-11.75c-4.874-6.375-5.624-13-2.125-19.88l25.75-50.87c11.37-22.5 8.999-49.38-6.374-70L52.28 187.9C47.28 181.4 46.78 174.5 50.53 167.8c4.374-8 16.37-16.88 34.12-15.5l65.11 5c25.25 2 51.12-7.125 68.11-24.37l41.74-42.63c8.874-9 23.87-12.5 37.87-8.75c11.12 2.875 19.25 9.75 21.5 18.38l14.5 54c6.249 23.37 24.1 42.25 50.12 50.75l60.74 20.5c11.62 3.875 18.87 11.75 19.62 21C464.6 254.6 459.2 262.4 449.3 267.4zM159.1 192c-17.62 0-31.1 14.37-31.1 31.1S142.4 256 159.1 256s31.1-14.37 31.1-31.1S177.6 192 159.1 192zM287.1 288c-17.62 0-31.1 14.37-31.1 31.1s14.38 31.1 31.1 31.1s31.1-14.37 31.1-31.1S305.6 288 287.1 288zM303.1 192c-8.874 0-15.1 7.124-15.1 15.1s7.126 15.1 15.1 15.1s15.1-7.124 15.1-15.1S312.9 192 303.1 192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDisease = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;